export default "__VITE_ASSET__lEKwgb2J__"